import React from 'react'

const NotFound = () => {
    return (
        <div>
            <section id="hero" style={{ background: "rgba(0, 0, 0, 0.1)" }}>
                <div className="container align-middle" data-aos="fade-up">

                    <h2 className=" text-center text-light" style={{ paddingTop: "300px", paddingBottom: "300px", fontSize:"30px" }} >NotFound</h2>

                </div>
            </section>
        </div>
    )
}

export default NotFound;
